import type { FetchConfigurationSpecificationsBodyType } from "../../../../common-deprecated/types/SpecTypes";
import { PriceCalculationServiceEndpoint } from "../../../../common-deprecated/types/SpecTypes";
import { COMPONENT_PDF } from "../../../../shared-logic/server/components";
import type { CarConfigStateType } from "../redux/store";
import { getExternalConfigOptionsAccessoryIdsDeprecated } from "../../../shared-logic/utils/typedUtils";
import { RequestStatusEnum } from "../../../../common-deprecated/types/CommonTypes";

/**
 *
 * @param state
 * @param returnSpecificationsMapping
 */
export const getConfigSpecsPayloadSelector = (
    state: CarConfigStateType,
    returnSpecificationsMapping: boolean,
): FetchConfigurationSpecificationsBodyType => {
    const { car, basket, items, externalPrice, commonSettings, carConfigSettings } = state;

    const isPdf = commonSettings.component === COMPONENT_PDF;

    // Get the ids (used for the texus call GetTechnicalSpecificationMappings
    const ids = getExternalConfigOptionsAccessoryIdsDeprecated(basket, items, false, true);
    // Get the short ids (used for the wltp CAR-DB API specifications call)
    const shortIds = getExternalConfigOptionsAccessoryIdsDeprecated(basket, items, true, true);
    const options = ids.options.map((id, index) => ({ id, shortId: shortIds.options[index] }));
    const accessories = ids.accessories.map((id, index) => ({ id, shortId: shortIds.accessories[index] }));
    const packs = basket.packs.filter((item) => !item.standard).map((item) => ({ id: item.id, shortId: item.shortId }));
    const serviceProducts = basket.serviceProducts.map((serviceProduct) => ({
        id: serviceProduct.id,
        shortId: serviceProduct.shortId,
    }));
    let taxLocationId;

    if ((carConfigSettings.enableExternalPrice && externalPrice.state !== RequestStatusEnum.Error) || isPdf) {
        taxLocationId = externalPrice.taxLocationId || "";
    }

    return {
        modelId: car.model.id,
        car: { id: car.id, shortId: car.shortId.toString() },
        wheel: { id: basket.wheel.id, shortId: basket.wheel.shortId },
        colour: { id: basket.colour.id, code: basket.colour.internalCode },
        upholstery: { id: basket.upholstery.id, code: basket.upholstery.internalCode },
        packs,
        serviceProducts,
        options,
        accessories,
        returnSpecificationsMapping,
        taxLocationId,
        priceCalculationServiceType: PriceCalculationServiceEndpoint.Prices,
    };
};
